export default "__VITE_ASSET__eaY9wt$6__"